import { SortDown, SortUp } from '@wix/wix-ui-icons-common/on-stage';
import React from 'react';
import { SORT } from '../../../../../../../Constants/TableHeader.Constants';
import { setSort } from '../../../../../../Services/Sort.service';
import { ActionsMenuLayout } from '@wix/wix-ui-tpa/cssVars';
import { setSelectedFolder } from '../../../../../../Services/SelectedFolder.service';
import { setIsLoading } from '../../../../../../Services/Loading.service';
import { changeSortDirection, getButtonDescriptionBi } from './helpers';
import biService from '../../../../../../BiEvents/BiService';
import { BI_FILE_SHARE_WIDGET_SORT_BY } from '../../../../../../BiEvents/Constants/BiConstants';
import { classes } from './ActionsMenuLayoutComponent.st.css';

const customBuildActionsMenuLayoutItem = ({
  id,
  content,
  sortBy,
  orientation,
  selectedFolderId,
  isMobile,
  setIsOpen,
  compId,
}: any) => {
  const handleOnClick = ({ selectedId }: any) => {
    if (sortBy === selectedId) {
      const tempOrientation = changeSortDirection({ orientation });
      setSort({ sortBy: selectedId, orientation: tempOrientation }, compId);
    } else {
      setSort({ orientation, sortBy: selectedId }, compId);
    }
    setIsLoading(true, compId);
    setSelectedFolder(selectedFolderId, compId);
    if (isMobile) {
      setIsOpen && setIsOpen(false);
    }
  };
  const PrefixIcon: any =
    sortBy === id ? (
      orientation === SORT.ORIENTATION.DESC ? (
        <SortDown className={classes.sortArrow} />
      ) : (
        <SortUp className={classes.sortArrow} />
      )
    ) : (
      <div></div>
    );
  return (
    <ActionsMenuLayout.Item
      key={id}
      onClick={() => {
        handleOnClick({
          selectedId: id,
        });
        biService(
          {
            button_description: getButtonDescriptionBi(id),
            is_first: false,
          },
          BI_FILE_SHARE_WIDGET_SORT_BY,
          compId,
        );
      }}
      content={content}
      prefixIcon={PrefixIcon}
    />
  );
};
export default customBuildActionsMenuLayoutItem;
